module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAlCAMAAAAUaRt1AAAAElBMVEVMaXHGFR3GFR3GFR3GFR3GFR3VCoeGAAAABXRSTlMAFdTIFtjb1OcAAABgSURBVHja7dIxDsAgDARBnIP/fzkSzUreiC4dbrCPEQXyaJXUONZaT52BhF9oQqCaEBhNGEgIfIlKABI7AEgwAogYAIStBRDTAJqY+xBAhHsAIiwAwN9jQF1wwb9AS/gCyqcCajpinnoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-28.png
// module id = y+Va
// module chunks = 15